import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';
import { calculators } from '../../common/js/calculator';
import ppfCalculator from '../ppfCalculator/ppfCalculator';

export const childEd = {
    variables: {
        childEdCalcWrapper: '.child__ed__wrapper',
        childEdCalcForm: '.child__ed--form',
        childEdCalcNameText: '.child__ed--name',
        childEdCalcNameInput: '.child__ed__name__input--wrapper',
        childEdCalcNameInputEl:'.child__ed__name--input',
        childEdCalcNamePlaceholder: '{name}',
        childEdCalcReplaceNameText: '.child__ed__name--text',
        childEdCalcDefaultName: '    ',
        childEdCalcAgeText: '.child__ed--age',
        childEdCalcAgeInput: '.child__ed__age__input--wrapper',
        childEdCalcAgeInputEl:'.child__ed__age--input',
        childEdCalcAgePlaceholder: '{age}',
        childEdCalcBackBtn: '.child__ed__cta--back',
        childEdCalcNextBtn: '.child__ed__cta--next',
        childEdCalcNameReplaceEl:'.child__ed__career--nametext',
        childEdCalcNameHeadingText:'.child__ed__career--container',
        childEdCalcCareerInput:'.child__ed--frequency',
        childEdCalcCostWrapper:'.child__ed__amount--wrapper',
        childEdCalcCostNameText:'.child__ed__dream--nametext',
        childEdCalcSavingWrapper:'.child__ed__saving--wrapper',
        childEdCalcSavingNameText:'.child__ed__dream--savingnametext',
        childEdCalcCostText:'.child__ed--cost',
        childEdCalcCostPlaceholder:'{cost}',
        childEdCalcCareerPlaceholder:'{career}',
        childEdCalcSavingText:'.child__ed--saving',
        childEdCalcSavingPlaceholder:'{savings}',
        childEdCalcYearsText:'.child__ed__year--wrapper',
        childEdCalcYearsPlaceholder:'{money}',
        childEdCalcMoneyNeed:'.child__ed__dream--yearnametext',
        childEdCalcMoneyNeedInput:'.child__ed__input__year--wrapper',
        childEdCalcUserNameText:'.child__ed__username--text',
        childEdCalcUserNameInput:'.child__ed__username__input--wrapper',
        childEdCalcUserMobileText:'.child__ed__usermobile--text',
        childEdCalcUserMobileInput:'.child__ed__usermobile__input--wrapper',
        childEdCalcUserMobilePlaceholder:'{mobile}',
        childEdCalcMaturityHeading:'.child__ed__maturity--heading',
        childEdCalcMaturityName:'.child__ed__maturity--name',
        childEdCalcMaturityCareer:'.child__ed__maturity--career',
        childEdCalcRorSelect:'.child__ed__ror--select',
        childEdCalcFreqSelect:'.child__ed__maturity--select',
        childEdCalcAmtReq:0,
        childEdCalcSavingAmt:0,
        childEdCalcCost:0,
        childEdCalcAmtDuration:0,
        childEdCalcRemainingYears:0,
        childEdCalcIsNegative:false,
        childMaturityAmountEl:'.child__ed__maturity--amount',
        childEdCalcRemainingYearsEl:'.child__ed__maturity__remaining--years',
        childEdCalcRemainingYearsPlaceholder:'{remainingYears}',
        childEdCalcTotalAmountWrapper:'.child__ed__maturity__total--wrapper',
        childEdCalcTotalAmountPlaceholder:'{totalamount}',
        childEdCalcTotalAmountText:'.child__ed__maturity--total',
        childEdCalcStartingInvestment:'.child__ed__invest--starting',
        childEdCalcInvestmentAmount:'.child__ed__invest--amount',
        childEdCalcInitialAgePlaceholder:'{initialAge}',
        childEdCalcInvestmentDuring:'.child__ed__investing--during',
        childEdCalcInvestmentDuringAmount:'.child__ed__investing--totalamount',
        childEdCalcInvestmentCompleted:'.child__ed__investing--completed',
        childEdCalcRecalculateBTN:'.child__ed--resetbtn',
        childEdCalcMobileInput:'.child__ed__mobile--input',
        childEdCalcData: [],
        name: null,
        mobile: null,
        fullName: null,
        mobileNumber: null
    },
    methods: {
        initialize: function () {
            const { childEdCalcWrapper } = childEd.variables;
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $self = this;
            $(childEdCalcWrapper).each(function (_, el) {
                $self.replaceNameInput(el);
                $self.replaceAgeInput(el);
                $self.replaceDreamCost(el);
                $self.replaceDreamSaving(el);
                $self.replaceDreamNeed(el);
                $self.replacePersonalInput(el);
                $self.validateRequiredInputHandler(el);
                $self.setCareer(el);
                $self.rorChange(el);
                $self.freqChange(el);
                $self.reCalculate(el);
                $self.submitForm(el);
            });
            /* eslint-disable @typescript-eslint/no-this-alias */
        },
        replaceNameInput: function (el) {
            const $el = $(el);
            const { childEdCalcNameText, childEdCalcNameInput, childEdCalcNamePlaceholder } = childEd.variables;
            const name = $el.find(childEdCalcNameInput).removeClass('d-none').detach();
            const nameText = $el.find(childEdCalcNameText);
            if (nameText.length > 0) {
                const replacedTextEl = nameText.html().replace(childEdCalcNamePlaceholder, name.prop('outerHTML'));
                nameText.html(replacedTextEl);
                calculators.methods.onlyText();
            }
        },
        replaceAgeInput: function (el) {
            const $el = $(el);
            const { childEdCalcAgeText, childEdCalcAgeInput, childEdCalcAgePlaceholder, childEdCalcReplaceNameText, childEdCalcNamePlaceholder, childEdCalcDefaultName } = childEd.variables;
            const age = $el.find(childEdCalcAgeInput).removeClass('d-none').detach();
            const nameText = $el.find(childEdCalcReplaceNameText).removeClass('d-none').text(`${childEdCalcDefaultName}`).detach();
            const ageText = $el.find(childEdCalcAgeText);
            if (ageText.length > 0) {
                const replacedTextEl = ageText.html().replace(childEdCalcAgePlaceholder, age.prop('outerHTML'))
                    .replace(childEdCalcNamePlaceholder, nameText.prop('outerHTML'));
                ageText.html(replacedTextEl);
                calculators.methods.onlyNumbers();
            }
        },
        replaceDreamCost:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const { childEdCalcCostText, childEdCalcCostWrapper, childEdCalcCostPlaceholder,childEdCalcCareerPlaceholder,childEdCalcCostNameText } = variables;
            const costText = $el.find(childEdCalcCostText).data('text');
            const nameText = $el.find(childEdCalcCostNameText).removeClass('d-none').detach();
            const costEl = $el.find(childEdCalcCostWrapper).removeClass('d-none').detach();
            if(costText.length > 0){
                const replacedTextEl = costText.replace(childEdCalcCostPlaceholder, costEl.prop('outerHTML'))
                   .replace(childEdCalcCareerPlaceholder, nameText.prop('outerHTML'));
            const costTextEl = $el.find(childEdCalcCostText);
            costTextEl.html(replacedTextEl);
            calculators.methods.currencyFormat();
            }
        },
        replaceDreamSaving:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const { childEdCalcSavingText, childEdCalcSavingWrapper, childEdCalcSavingPlaceholder,childEdCalcSavingNameText,childEdCalcNamePlaceholder } = variables;
            const costText = $el.find(childEdCalcSavingText).data('text');
            const nameText = $el.find(childEdCalcSavingNameText).removeClass('d-none').detach();
            const costEl = $el.find(childEdCalcSavingWrapper).removeClass('d-none').detach();
            if(costText.length > 0){
                const replacedTextEl = costText.replace(childEdCalcSavingPlaceholder, costEl.prop('outerHTML'))
                   .replace(childEdCalcNamePlaceholder, nameText.prop('outerHTML'));
            const costTextEl = $el.find(childEdCalcSavingText);
            costTextEl.html(replacedTextEl);
            calculators.methods.currencyFormat();
            }
        },
        replaceDreamNeed:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const { childEdCalcMoneyNeedInput, childEdCalcYearsText, childEdCalcYearsPlaceholder,childEdCalcMoneyNeed,childEdCalcNamePlaceholder } = variables;
            const costText = $el.find(childEdCalcYearsText).data('text');
            const nameText = $el.find(childEdCalcMoneyNeed).removeClass('d-none').detach();
            const costEl = $el.find(childEdCalcMoneyNeedInput).removeClass('d-none').detach();
            if(costText.length > 0){
                const replacedTextEl = costText.replace(childEdCalcYearsPlaceholder, costEl.prop('outerHTML'))
                   .replace(childEdCalcNamePlaceholder, nameText.prop('outerHTML'));
            const costTextEl = $el.find(childEdCalcYearsText);
            costTextEl.html(replacedTextEl);
            calculators.methods.onlyNumbers();
            }
        },
        replacePersonalInput:function(el){
            const $el = $(el);
            const {childEdCalcUserNameText, childEdCalcUserNameInput,childEdCalcNamePlaceholder, childEdCalcUserMobileText, childEdCalcUserMobileInput,childEdCalcUserMobilePlaceholder} = childEd.variables;
            const nameText = $el.find(childEdCalcUserNameText);
            const mobileText = $el.find(childEdCalcUserMobileText);
            const nameInput = $el.find(childEdCalcUserNameInput).removeClass('d-none').detach();
            const mobileInput = $el.find(childEdCalcUserMobileInput).removeClass('d-none').detach();
            if(nameText.length > 0 && mobileText.length > 0){
                const replacedNameTextEl = nameText.html().replace(childEdCalcNamePlaceholder, nameInput.prop('outerHTML'));
                const replaceMobileTextEl = mobileText.html().replace(childEdCalcUserMobilePlaceholder, mobileInput.prop('outerHTML'));
                nameText.html(replacedNameTextEl);
                mobileText.html(replaceMobileTextEl);
                calculators.methods.onlyNumbers();
                calculators.methods.onlyText();
            }
        },
        replaceMaturityCareerName:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const {childEdCalcMaturityHeading,childEdCalcMaturityName,childEdCalcMaturityCareer,childEdCalcNamePlaceholder,childEdCalcCareerPlaceholder} = variables;
            const nameHeading = $el.find(childEdCalcMaturityHeading).data('text');
            const maturityName = $el.find(childEdCalcMaturityName).text(`${variables.childEdCalcData[0]["child-name"].trim().split(' ')[0]}'s`).detach();
            const maturityCareer = $el.find(childEdCalcMaturityCareer).text(`${variables.childEdCalcData[0]["career"]}`).detach();
            if(nameHeading.length > 0 ){
                const replacedNameTextEl = nameHeading.replace(childEdCalcNamePlaceholder, maturityName.prop('outerHTML'))
                                            .replace(childEdCalcCareerPlaceholder, maturityCareer.prop('outerHTML'));
                                            $el.find(childEdCalcMaturityHeading).html(replacedNameTextEl);
        }
        },
        setChildNameDuringJourney:function(el){
            const $el = $(el);
            const {variables}= childEd;
            const {childEdCalcMoneyNeed,childEdCalcSavingNameText,childEdCalcCostNameText} = variables;
            $el.find(childEdCalcMoneyNeed).text(`${variables.childEdCalcData[0]["child-name"].trim().split(' ')[0]}`);
            $el.find(childEdCalcSavingNameText).text(`${variables.childEdCalcData[0]["child-name"].trim().split(' ')[0]}`);
            $el.find(childEdCalcCostNameText).text(`${variables.childEdCalcData[0]["career"]}`);
        },
        setCareer:function(el){
            const $el = $(el);
            const { childEdCalcCareerInput } = childEd.variables;
            const {CHANGE, INPUT} = CONSTANT.eventsListners;
            const careerInput = $el.find(childEdCalcCareerInput);
            if(careerInput.length > 0){
                $(careerInput).on(CHANGE,function(){
                    const $this = $(this);
                    const selectedValue = $this.val();
                    $this.parent().siblings('.child__ed__others--wrapper').removeClass('error__active').find('.error').remove();
                    if(selectedValue.toLowerCase() === 'others'){
                        $this.parent().siblings('.child__ed__others--wrapper').removeClass('d-none').find('.child__ed__other--input').prop('disabled',false);
                    }else{
                        $this.parent().siblings('.child__ed__others--wrapper').addClass('d-none').find('.child__ed__other--input').prop('disabled',true);
                    }
                });
            }
            $el.find('input:not([type="radio"]):not([type="checkbox"])').on(INPUT,(e)=>{
                const input = e.target;
                const newWidth = input.value.length + "ch";
                if (input.style.width !== newWidth) {
                    input.style.width = newWidth;
                }
            });
        },
        validateRequiredInputHandler:function(el){
            const $el = $(el);
            const {childEdCalcNameInputEl,childEdCalcAgeInputEl,childEdCalcReplaceNameText,childEdCalcDefaultName,childEdCalcMobileInput} = childEd.variables;
            const {BLUR} = CONSTANT.eventsListners;
            $el.find(childEdCalcMobileInput).on(CONSTANT.eventsListners.INPUT,function(e){
                const mobileValue = $(this).val();
                if (mobileValue.length > 0 && (!/^[6-9][0-9]*$/.test(mobileValue))) {
                    e.target.value = mobileValue.slice(0, -1);
                }
            });
            $el.find(childEdCalcNameInputEl).on(BLUR,function(e){
                const nameInputVal = $(childEdCalcNameInputEl).val();
                localStorage.setItem('child_ed-name',nameInputVal);
                if(nameInputVal.length >= 3){
                    $(childEdCalcReplaceNameText).text(`${nameInputVal.trim().split(' ')[0]}'s`);
                }
                else{
                    $(childEdCalcReplaceNameText).text(childEdCalcDefaultName);
                }
            });
        },
        calculateChildMaturity:function(amount,initialAge,career,careerStartAge,saving,ror,infRate,freq){
            const {variables} = childEd;

                let freqInNumber = 12;
                if(freq === 'yearly'){
                    freqInNumber = 1;
                }
                else if(freq === 'half-yearly'){
                    freqInNumber = 2;
                }
                else if(freq === 'quarterly'){
                    freqInNumber = 4;
                }
                else{
                    freqInNumber = 12;
                }
                let monthlyFrequency = 12;
                if(freq === 'yearly'){
                    monthlyFrequency = 12;
                }
                else if(freq === 'half-yearly'){
                    monthlyFrequency = 6;
                }
                else if(freq === 'quarterly'){
                    monthlyFrequency = 3;
                }
                else{
                    monthlyFrequency = 1;
                }
                let monre = 0;

                if (amount.trim() === '') {
                  var curr_cost = '0';
                } else {
                  var curr_cost = amount;
                }
                var childage = initialAge;
                var coures = career;
                localStorage.setItem('child_ed-career',career);
                var curr_cost = amount;
                localStorage.setItem('child-ed-curr_cost',curr_cost);

                var high_edu = careerStartAge;
                if (saving.trim() === '') {
                  var save_amt = '0';
                } else {
                  var save_amt = saving;
                }
               var save_unit = $('#sell_1').val();
                var rate = ror;
                let infrate = infRate;
                //alert(save_amt);
                let diff = parseInt(high_edu) - parseInt(childage);
                variables.childEdCalcRemainingYears = diff;
                var p = (1 + parseInt(infrate) / parseInt(100));
                var c = Math.pow(parseFloat(p), parseInt(diff));
                let fcost = Math.round(curr_cost * parseFloat(c));

                var sp = (1 + parseInt(rate) / parseInt(100));
                var sc = Math.pow(parseFloat(sp), parseInt(diff));

                var cursave = parseFloat(save_amt);

                let fsaving = (parseInt(cursave * parseFloat(sc)));
                let amtReq = (parseInt(fcost) - parseInt(fsaving));

                variables.childEdCalcAmtReq = amtReq;
                variables.childEdCalcSavingAmt = fsaving;
                variables.childEdCalcCost = fcost;


                if (amtReq.toString().substring(0, 1) == '-' || parseInt(fsaving) >= parseInt(fcost)) {
                  monre = 0;
                  variables.childEdCalcAmtDuration = monre;
                  variables.childEdCalcIsNegative=true;


                } else {

                 var ir1 = parseFloat((parseInt(infrate)/100)/12);

                  var PV   = 0;         //Present Value
                  var FV   = parseFloat(amtReq);             //Future Value
                  var IYR  = ror;              //Interest Rate
                  var FREQ = freqInNumber;             //Payment Frequency
                  var ADV  = 0;              //No. of advance payments
                  var TERM = parseFloat(diff*freqInNumber);             //Term of the Loan
                  var N    = ADV + TERM;
                  var SIR = rate/1200;
                  var  UIR = (IYR / 100) / FREQ;
                  var  N   = ADV + TERM;
                  let newValue = (amtReq * SIR) / (Math.pow(1 + (SIR*12), diff) - 1) * monthlyFrequency;
                  var  SPPV = 1 / (Math.pow((1 + (SIR / 100)), N));
                  var  USPV = (Math.pow(1 + UIR, TERM) - 1) / (UIR * (Math.pow(1 + UIR, TERM)));
                  monre = Math.abs((PV - FV * SPPV) / (USPV + ADV));
                   monre=monre.toFixed(2);
                   variables.childEdCalcAmtDuration = newValue.toFixed(2);
                }
                const costValue = $('.chli__calculator--rupee').find('input').val();
                localStorage.setItem('child_ed-cost',costValue);

                const saving_childED=$(childEd.variables.childEdCalcSavingText).find('input').val();
                localStorage.setItem('child_ed-saving',saving_childED);

                const contact=$('.child__ed__mobile--input').val();
                localStorage.setItem('child_ed-contact',contact);
                childEd.variables.mobile=contact;

                const age=document.getElementsByClassName("child__ed__age--input")[0].value;
                localStorage.setItem('child_ed-age',age);

                const ageNeeded=$('.child__ed--year').val();
                localStorage.setItem('child-ed-ageNeeded',ageNeeded);

                const parentAge=$($('.child__ed__name--input')[1]).val();
                localStorage.setItem('child-ed-parentName',parentAge);
                childEd.variables.name=parentAge;
     },
        setDurationAmt:function(el){
            const {variables} = childEd;
            const {childMaturityAmountEl} = variables;
            const $el = $(el);
            if(!variables.childEdCalcIsNegative){
                const NumberCalcAmountDuration = Math.trunc(Number(ppfCalculator.methods.removeCommas(variables.childEdCalcAmtDuration))).toString();
                $el.find(childMaturityAmountEl).text(`₹ ${ppfCalculator.methods.formatNumber(NumberCalcAmountDuration)}`);
                }
        },
        setRemainingYears:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const {childEdCalcRemainingYears,childEdCalcRemainingYearsEl,childEdCalcRemainingYearsPlaceholder} = variables;
            const remaining = $el.find(childEdCalcRemainingYearsEl);
            const replacedText = remaining.data('text').replace(childEdCalcRemainingYearsPlaceholder,childEdCalcRemainingYears);
            remaining.text(replacedText);
        },
        setTotalAmount:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const {childEdCalcTotalAmountWrapper,childEdCalcTotalAmountPlaceholder,childEdCalcTotalAmountText} = variables;
            const totalAmount = $el.find(childEdCalcTotalAmountWrapper).data('text');
            const totalAmountText = $el.find(childEdCalcTotalAmountText).text(`₹ ${ppfCalculator.methods.formatNumber(variables.childEdCalcCost)}`).detach();
            const newTotalAmountEl = totalAmount.replace(childEdCalcTotalAmountPlaceholder,totalAmountText.prop('outerHTML'));
            $el.find(childEdCalcTotalAmountWrapper).html(newTotalAmountEl);
        },
        setStartingInvestmentText:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const {childEdCalcStartingInvestment, childEdCalcInvestmentAmount,childEdCalcInitialAgePlaceholder,childEdCalcNamePlaceholder,childEdCalcFreqSelect} = variables;
            const initialInvestment = $el.find(childEdCalcStartingInvestment);
            const selectedFreq = $el.find(childEdCalcFreqSelect).find(":selected").val();
            const initialInvestmentUpdatedText = initialInvestment.data('text').replace(childEdCalcInitialAgePlaceholder,variables.childEdCalcData[0]["child-age"])
                                                .replace(childEdCalcNamePlaceholder,`${variables.childEdCalcData[0]["child-name"].trim().split(' ')[0]}'s`);
            initialInvestment.html(initialInvestmentUpdatedText);
            $el.find(childEdCalcInvestmentAmount).text(`₹ ${ppfCalculator.methods.formatNumber(Math.trunc(Number(variables.childEdCalcAmtDuration)).toString())} ${selectedFreq}`);
        },
        setInvestmentDuring:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const {childEdCalcInvestmentDuring,childEdCalcInvestmentDuringAmount,childEdCalcNamePlaceholder} = variables;
            const investmentDuring = $el.find(childEdCalcInvestmentDuring);
            const investmentDuringUpdatedText = investmentDuring.html().replace(childEdCalcNamePlaceholder, `${variables.childEdCalcData[0]["child-name"].trim().split(' ')[0]}`);
            investmentDuring.html(investmentDuringUpdatedText);
            $el.find(childEdCalcInvestmentDuringAmount).text(`₹ ${ppfCalculator.methods.formatNumber(variables.childEdCalcCost)}`);
        },
        setInvestmentCompleted:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const {childEdCalcInvestmentCompleted,childEdCalcNamePlaceholder,childEdCalcCareerPlaceholder} = variables;
            const completedText = $el.find(childEdCalcInvestmentCompleted);
            const replacedCompletedText = completedText.data('text').replace(childEdCalcNamePlaceholder,`${variables.childEdCalcData[0]["child-name"].trim().split(' ')[0].charAt(0).toUpperCase() + variables.childEdCalcData[0]["child-name"].trim().split(' ')[0].slice(1)}`)
                                        .replace(childEdCalcCareerPlaceholder,variables.childEdCalcData[0]["career"].charAt(0).toUpperCase() + variables.childEdCalcData[0]["career"].slice(1));
                                        completedText.html(replacedCompletedText);

        },
        rorChange:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const {childEdCalcRorSelect,childEdCalcFreqSelect} = variables;
            const {CHANGE} = CONSTANT.eventsListners;
            /* eslint-disable @typescript-eslint/no-this-alias */
            const $self = this;
            $el.find(childEdCalcRorSelect).on(CHANGE,function(e){
                const infRate =$el.data('infr-rate');
                const freq = $el.find(childEdCalcFreqSelect).find(":selected").val();
                const sanitizeCost = ppfCalculator.methods.removeCommas(variables.childEdCalcData[0]["cost"]);
                const sanitizeSaving = ppfCalculator.methods.removeCommas(variables.childEdCalcData[0]["saving"]);
                const selectedRor = $(this).find(":selected").val();
                $self.calculateChildMaturity(sanitizeCost,variables.childEdCalcData[0]["child-age"],variables.childEdCalcData[0]["career"],variables.childEdCalcData[0]["year"],sanitizeSaving,selectedRor,infRate,freq);
                $self.setDurationAmt(el);
                $self.setRemainingYears(el);
                $self.setTotalAmount(el);
                $self.setStartingInvestmentText(el);
                $self.setInvestmentDuring(el);
                $self.setInvestmentCompleted(el);
                $self.replaceMaturityCareerName(el);

            });
                /* eslint-disable @typescript-eslint/no-this-alias */
            },
            freqChange:function(el){
                const $el = $(el);
                const {variables} = childEd;
                const {childEdCalcRorSelect,childEdCalcFreqSelect} = variables;
                const {CHANGE} = CONSTANT.eventsListners;
                /* eslint-disable @typescript-eslint/no-this-alias */
                const $self = this;
                $el.find(childEdCalcFreqSelect).on(CHANGE,function(e){
                    const infRate =$el.data('infr-rate');
                    const freq = $(this).find(":selected").val();
                    const sanitizeCost = ppfCalculator.methods.removeCommas(variables.childEdCalcData[0]["cost"]);
                    const sanitizeSaving = ppfCalculator.methods.removeCommas(variables.childEdCalcData[0]["saving"]);
                    const selectedRor = $el.find(childEdCalcRorSelect).find(":selected").val();
                    $self.calculateChildMaturity(sanitizeCost,variables.childEdCalcData[0]["child-age"],variables.childEdCalcData[0]["career"],variables.childEdCalcData[0]["year"],sanitizeSaving,selectedRor,infRate,freq);
                    $self.setDurationAmt(el);
                    $self.setRemainingYears(el);
                    $self.setTotalAmount(el);
                    $self.setStartingInvestmentText(el);
                    $self.setInvestmentDuring(el);
                    $self.setInvestmentCompleted(el);
                    $self.replaceMaturityCareerName(el);
                });
                    /* eslint-disable @typescript-eslint/no-this-alias */
            },
            reCalculate:function(el){
                const $el = $(el);
                const {variables} = childEd;
                const {childEdCalcRecalculateBTN,childEdCalcNextBtn,childEdCalcForm,childEdCalcReplaceNameText,childEdCalcDefaultName} = variables;
                const {CLICK} = CONSTANT.eventsListners;
                $el.find(childEdCalcRecalculateBTN).on(CLICK,function(e){
                    $el.find(childEdCalcForm).get(0).reset(childEdCalcDefaultName);
                    $el.find(childEdCalcReplaceNameText).text(childEdCalcDefaultName);
                    $el.find('[data-page], [data-inner-page]').removeClass('active');
                    $el.find('[data-page="1"],[data-inner-page="2.1"]').addClass('active');
                    $el.find(childEdCalcNextBtn).removeClass('d-none');
            });
        },
        validateCareerAge:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const {childEdCalcMoneyNeedInput} = variables;
            if(variables.childEdCalcData.length > 0 && variables.childEdCalcData[0]["year"].length > 0){
                if(Number(variables.childEdCalcData[0]["child-age"]) >= Number(variables.childEdCalcData[0]["year"])){
                    if(Number(variables.childEdCalcData[0]["year"] >=16)){
                    $el.find(childEdCalcMoneyNeedInput).addClass('error__active');
                    $el.find(childEdCalcMoneyNeedInput).append(`<span class="error">Career age is ${variables.childEdCalcData[0]["year"]} should be greater than current age${variables.childEdCalcData[0]["child-age"]}</span>`);
                    }
                }
                else{
                    $el.find(childEdCalcMoneyNeedInput).removeClass('error__active');
                    $el.find(childEdCalcMoneyNeedInput).find('.error').remove();
                }
            }
        },
        validateCost:function(el){
            const $el = $(el);
            const {variables} = childEd;
            const {childEdCalcMoneyNeedInput,childEdCalcSavingWrapper} = variables;
            if(variables.childEdCalcData.length > 0 && variables.childEdCalcData[0]["saving"].length > 0){
                if(Number(ppfCalculator.methods.removeCommas(variables.childEdCalcData[0]["saving"])) >= Number(ppfCalculator.methods.removeCommas(variables.childEdCalcData[0]["cost"]))){
                    $el.find(childEdCalcSavingWrapper).addClass('error__active');
                    $el.find(childEdCalcSavingWrapper).append(`<span class="error">Cost is ${variables.childEdCalcData[0]["cost"]} should be greater than saving ${variables.childEdCalcData[0]["saving"]}</span>`);
                }
                else{
                    $el.find(childEdCalcSavingWrapper).removeClass('error__active');
                    $el.find(childEdCalcSavingWrapper).find('.error').remove();
                }
            }
        },
        submitForm: function (el) {
            const $el = $(el);
            const { variables } = childEd;
            const { childEdCalcForm, childEdCalcBackBtn, childEdCalcNameHeadingText,childEdCalcNextBtn,childEdCalcRorSelect,childEdCalcFreqSelect,childMaturityAmountEl } = variables;
            const { eventsListners: { CLICK, SUBMIT } } = CONSTANT;
             /* eslint-disable @typescript-eslint/no-this-alias */
            const $self = this;
            $el.find(childEdCalcForm).on(SUBMIT, function (e) {
                e.preventDefault();
                calculators.methods.validateRequiredFields($el);
                calculators.methods.validateLength($el);
                const $this = $(this);
                const childEdData = $this.serializeArray();
                const dataObject = childEdData.reduce((accumulator, item) => {
                    accumulator[item.name] = item.value;
                    return accumulator;
                }, {});
                variables.childEdCalcData.length > 0 && variables.childEdCalcData.splice(0, variables.childEdCalcData.length);
                variables.childEdCalcData.push(dataObject);
                $self.validateCareerAge(el);
                $self.validateCost(el);
                const isError = $el.find('.error__active');
                if (isError.length) { return; }
                const name = variables.childEdCalcData[0]["child-name"].trim().split(' ')[0];
                $self.setChildNameDuringJourney(el);
                $self.setName(el,childEdCalcNameHeadingText,`${name}'s`);
                const currentPage = $el.find('[data-page].active');
                    if(currentPage.find('[data-inner-page]').length > 0 && currentPage.find('[data-inner-page].active').next('[data-inner-page]').length > 0){
                            currentPage.find('[data-inner-page].active').removeClass('active').next('[data-inner-page]').addClass('active');
                    }
                else{
                const isBack = calculators.methods.handleNextPrev(el, false);
                if (isBack) {
                    $el.find(childEdCalcBackBtn).removeClass('d-none');
                }
                else{
                    const infRate =$el.data('infr-rate');
                    const ror = $(childEdCalcRorSelect).find(':selected').val();
                    const freq = $(childEdCalcFreqSelect).find(":selected").val();
                    const sanitizeCost = ppfCalculator.methods.removeCommas(variables.childEdCalcData[0]["cost"]);
                    const sanitizeSaving = ppfCalculator.methods.removeCommas(variables.childEdCalcData[0]["saving"]);
                    $el.find(childEdCalcBackBtn).addClass('d-none');
                    $el.find(childEdCalcNextBtn).addClass('d-none');
                    $self.calculateChildMaturity(sanitizeCost,variables.childEdCalcData[0]["child-age"],variables.childEdCalcData[0]["career"],variables.childEdCalcData[0]["year"],sanitizeSaving,ror,infRate,freq);
                    $self.setDurationAmt(el);
                    $self.setRemainingYears(el);
                    $self.setTotalAmount(el);
                    $self.setStartingInvestmentText(el);
                    $self.setInvestmentDuring(el);
                    $self.setInvestmentCompleted(el);
                    $self.replaceMaturityCareerName(el);
                }
                }
                 /* eslint-disable @typescript-eslint/no-this-alias */

            });
            $el.find(childEdCalcBackBtn).on(CLICK, function () {
                const currentPage = $el.find('[data-page].active');
                if(currentPage.find('[data-inner-page]').length > 0 && currentPage.find('[data-inner-page].active').prev('[data-inner-page]').length > 0){
                        currentPage.find('[data-inner-page].active').removeClass('active').prev('[data-inner-page]').addClass('active');
                }
                else{
                    const isBack = calculators.methods.handleNextPrev(el, true);
                    if (isBack) {
                        $el.find(childEdCalcBackBtn).removeClass('d-none');
                    }
                    else {
                        $el.find(childEdCalcBackBtn).addClass('d-none');
                    }
                }
            });
        },
        setName:function(el,selector,name){
            const $el = $(el);
            const {childEdCalcNamePlaceholder,childEdCalcNameReplaceEl} = childEd.variables;
            const nameText = $el.find(selector).data('text');
            const nameHtml = $el.find(selector);
            const nameWrapper = nameHtml.find(childEdCalcNameReplaceEl).removeClass('d-none').text(name).detach();
            if(nameText.length > 0){
                const replacedTextEl = nameText.replace(childEdCalcNamePlaceholder, nameWrapper.prop('outerHTML'));
                nameHtml.html(replacedTextEl);
            }
        },
        dataLayerObj: function (e ,pageSection,section,name,mobile) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e.currentTarget.querySelector('span')?.innerText.trim() || '',
                'pageSection' : pageSection ? pageSection.replace(/\n/g, '').trim().concat('_').concat(section).replace(/\n/g, '').trim() : "",
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : document.getElementById('productCategoryName') ? document.getElementById('productCategoryName').value : "",
                'productName' : document.getElementById('productPlanName') ? document.getElementById('productPlanName').value : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
                "name": name? name: "",
                "mobileNumber": mobile ? mobile : "",
                "countryCode" : "+91",
            };
            return obj;
        },
        init: function (el) {
            this.initialize();

        $('.child__ed__cta--next').on('click', function(e){

            let container=$(this).closest('.childEducation')
            .find(".child__ed--page.active");

            let calculatorName=$(this).closest('.childEducation')
            .find('.chli__calculator--title').text();

            let calculatorSection=$(this).closest('.childEducation')
            .find('.chli__calculator--step.active')
            .find('.chli__calculator__step--label').text();

               let name=null;
               let mobile=null;
               if(container){
                name=container.find('.child__ed__name--input').val();
                mobile=container.find('.child__ed__mobile--input').val();
                childEd.variables.fullName = name;
                childEd.variables.mobileNumber = mobile;
            }
            var obj = childEd.methods.dataLayerObj(e,calculatorName, calculatorSection,name,mobile);
            createDataLayer('buttonClick', obj);
             });
            $('.child__ed__cta--back').on('click', function(e){

            let calculatorName=$(this).closest('.childEducation')
            .find('.chli__calculator--title').text();

            let calculatorSection=$(this).closest('.childEducation')
            .find('.chli__calculator--step.active')
            .find('.chli__calculator__step--label').text();

              var obj = childEd.methods.dataLayerObj(e,calculatorName,calculatorSection,childEd.variables.fullName,childEd.variables.mobileNumber);
              createDataLayer('buttonClick', obj);
            });
            $('.child__ed--resetbtn').on('click', function(e){
                let calculatorName=$(this).closest('.childEducation')
            .find('.chli__calculator--title').text();

            let calculatorSection=$(this).closest('.childEducation')
            .find('.chli__calculator--step.active')
            .find('.chli__calculator__step--label').text();
              var obj = childEd.methods.dataLayerObj(e,calculatorName,calculatorSection);
              createDataLayer('buttonClick', obj);
            });
            $('.child__ed--link').on('click', function(e){

                let calculatorName=$(this).closest('.childEducation')
            .find('.chli__calculator--title').text();

            let calculatorSection=$(this).closest('.childEducation')
            .find('.chli__calculator--step.active')
            .find('.chli__calculator__step--label').text();

              var obj = childEd.methods.dataLayerObj(e,calculatorName,calculatorSection,childEd.variables.fullName,childEd.variables.mobileNumber);
              createDataLayer('buttonClick', obj);
            });
        }
    }
};


$(() => {
    const { childEdCalcWrapper } = childEd.variables;
    if ($(childEdCalcWrapper).length > 0) {
        childEd.methods.init();
    }
});
